import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, TOKEN } from "../../../variables/constants";

const AddPrejudice = ({
  editMode,
  selectedPrejudice,
  onActionComplete,
  prejudices,
  handleClose,
}) => {
  const [loading, setLoading] = useState(false);
  const [libellePrejudice, setLibellePrejudice] = useState("");
  const [montant, setMontant] = useState("");

  useEffect(() => {
    if (editMode && selectedPrejudice) {
      setLibellePrejudice(selectedPrejudice.libellePrejudice || "");
      setMontant(selectedPrejudice.montant || "");
    } else {
      setLibellePrejudice("");
      setMontant("");
    }
  }, [editMode, selectedPrejudice]);

  const validateForm = () => {
    const trimmedLibelle = libellePrejudice.trim();
    if (!trimmedLibelle) {
      toast.error("Le libellé du préjudice est obligatoire et ne peut pas être vide.");
      return false;
    }
    
    const parsedMontant = parseFloat(montant);
    if (isNaN(parsedMontant) || parsedMontant < 0) {
      toast.error("Le montant doit être un nombre valide et positif.");
      return false;
    }

    const isDuplicate = prejudices?.some(
      (p) =>
        p.libellePrejudice.toLowerCase() === trimmedLibelle.toLowerCase() &&
        (!editMode || p.codeId !== selectedPrejudice?.codeId)
    );
    if (isDuplicate) {
      toast.error("Un préjudice avec ce libellé existe déjà.");
      return false;
    }

    return true;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    const prejudiceData = {
      ...(editMode && selectedPrejudice ? { codeId: selectedPrejudice.codeId } : {}),
      libellePrejudice: libellePrejudice.trim(),
      montant: parseFloat(montant),
    };

    try {
      let res;
      if (editMode) {
        res = await axios.put(`${API_URL}/api/prejudice`, prejudiceData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${TOKEN}`,
          },
        });
        toast.success("Préjudice modifié avec succès.");
      } else {
        res = await axios.post(`${API_URL}/api/prejudice`, prejudiceData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${TOKEN}`,
          },
        });
        toast.success("Préjudice ajouté avec succès.");
      }
      
      // DIAGNOSTIC : Log la réponse de l'API après un ajout/modification
      console.log("Réponse API (ajout/modification) :", res.data);

      handleClose();
      if (onActionComplete) {
        onActionComplete();
      }
    } catch (error) {
      console.error(
        "Erreur lors de l'enregistrement :",
        error.response?.data || error.message
      );
      toast.error("Erreur lors de l'enregistrement du préjudice.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <div className="text-center mb-4">
        <h4>{editMode ? "Modifier le" : "Ajouter un"} préjudice</h4>
        <p className="text-muted">
          {editMode
            ? "Apportez vos modifications et enregistrez."
            : "Remplissez les informations pour ajouter un nouveau préjudice."}
        </p>
      </div>
      <div className="mb-3">
        <label className="form-label">Libellé Préjudice</label>
        <input
          type="text"
          className="form-control"
          placeholder="Entrez le libellé du préjudice"
          value={libellePrejudice}
          onChange={(e) => setLibellePrejudice(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Montant</label>
        <input
          type="number"
          className="form-control"
          placeholder="Entrez le montant"
          value={montant}
          onChange={(e) => setMontant(e.target.value)}
          required
        />
      </div>
      <div className="text-center">
        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading}
        >
          {loading ? "Enregistrement..." : "Enregistrer"}
        </button>
        <button
          type="button"
          className="btn btn-secondary ms-3"
          onClick={handleClose}
          disabled={loading}
        >
          Annuler
        </button>
      </div>
    </form>
  );
};

export default AddPrejudice;
